import React, { Component } from 'react';

class getCCliente extends Component {
  constructor(){ 
    super();
    this.state = {
      busqueda : localStorage.getItem("numero_temp"),
      clientes : [],
      accion : 'busqueda',
      new_telefono : "",
      new_nombre:'',
      id_cliente:0,
      msg_loading:false,
      uuid:''
    }
    //

  }
  inputChangedHandlerTelefono=(event)=>{
    this.setState({
      new_telefono :event.target.value
    })
  }
  inputChangedHandlerBusqueda=(event)=>{
    this.setState({
      busqueda :event.target.value
    }, ()=>{
      this.getClientes()
    })
  }
  inputChangedHandlerCliente=(event)=>{
    this.setState({
      new_nombre :event.target.value
    })
  }
  getRegresar=()=>{
    this.props.getRegresar()
  }
  geteditCliente =(id_cliente,nombre,codigo,uuid)=>{
    this.setState({
      id_cliente,
      accion:'editar',
      new_nombre:nombre,
      new_telefono:codigo,
      uuid
    })
  }
  getnewCliente =()=>{
    this.setState({
      new_telefono:this.state.busqueda,
      accion:'nuevo'
    })
  }
  getDataBusqueda =()=>{
    const clientes = this.state.clientes
    //id_clientes, codigo, correo, clave, nombre, uuid_cliente, id_forma_pago, id_datos_facturacion
    return(
       <React.Fragment>
       <tbody>
        {clientes.map((cliente , index) => (
          <React.Fragment key={index}>
          <tr>
            <td>{cliente.nombre}</td>
            <td>{cliente.codigo}</td>
            <td>{cliente.correo}</td>
            <td onClick={ () =>
              this.geteditCliente(cliente.id_clientes,cliente.nombre,cliente.codigo,cliente.uuid_cliente)}
              >Seleccionar</td>
          </tr>
          </React.Fragment>
        ) ) }
      </tbody>
      </React.Fragment>
    )
  }
  geteditClienteFinalizar =()=>{
    const new_telefono = this.state.new_telefono.trim()
    const new_nombre = this.state.new_nombre.trim()
    if(new_telefono===''){
      alert('Ingrese Teléfono')
      return null
    }
    if(new_nombre===''){
      alert('Ingrese Nombre')
      return null
    }
    this.getNewEditClientes(1)
  }
  getnewClienteFinalizar =()=>{
    const new_telefono = this.state.new_telefono.trim()
    const new_nombre = this.state.new_nombre.trim()
    if(new_telefono===''){
      alert('Ingrese Teléfono')
      return null
    }
    if(new_nombre===''){
      alert('Ingrese Nombre')
      return null
    }
    this.getNewEditClientes(0)
  }
  get_loading =(msg_loading)=>{
    this.setState({
      msg_loading
    })
  }
  getNewEditClientes =(opcion)=>{
    const url= this.props.dir_url + "webapp/getNewEditCliente";
    const token =  this.props.token
    const nombre = this.state.new_nombre
    const codigo = this.state.new_telefono
    const id_cliente =this.state.id_cliente
    const uuid_new = this.state.uuid
    var obj = { accion:'dataneweditcliente', token,nombre,codigo,opcion,id_cliente,uuid_new};
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      if(data[0].status==="ok"){
        this.props.getDataCliente(data[0].msg,nombre,data[0].uuid)
        this.get_loading(false);
      }
    })
    .catch(console.log)
    this.get_loading(true);
  }

  getClientes =()=>{
    const url= this.props.dir_url + "webapp/getDataCliente";
    const token =  this.props.token
    const cliente = this.state.busqueda
    var obj = { accion:'datacliente', token, cliente };
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      if(data[0].status==="ok"){
        this.setState({
          clientes :data[0].msg
        })
      }else{
        this.setState({
          clientes :[]
        })
      }
    })
    .catch(console.log)
  }

  DataBusqueda =()=>{
    return (
      <React.Fragment>
        <button style={{"width":"150px"}} className="button-global"
         onClick={ () => this.getRegresar()}>
          Regresar
        </button>
        <br/>
        Búscar por Número Teléfonico o Nombre
        <input style={{"width":"100%"}} value={this.state.busqueda}
        onChange={(event)=>this.inputChangedHandlerBusqueda(event)}
        className="input-global" placeholder="Búscar por Número Teléfonico o Nombre" />
        <br/>
        <button style={{"width":"150px"}} className="button-global"
         onClick={ () => this.getnewCliente()}>
          Crear Cliente
        </button>
        <br/>
        <table className="tb_pedidos">
          <thead>
          <tr>
            <th>Cliente</th>
            <th>Télefono</th>
            <th>Correo</th>
            <th>Opciones</th>
          </tr>
          </thead>
          {this.getDataBusqueda()}
        </table>
      </React.Fragment>
    )
  }
  DataNuevo =()=>{
    return (
      <React.Fragment>
        <button style={{"width":"150px"}} className="button-global"
         onClick={ () => this.getRegresar()}>
          Regresar
        </button>
        <br/>
        Teléfono:
        <input style={{"width":"100%"}} value={this.state.new_telefono}
        onChange={(event)=>this.inputChangedHandlerTelefono(event)}
        className="input-global" placeholder="Número Telefónico" />
        <br/>
        Cliente:
        <input style={{"width":"100%"}} value={this.state.new_nombre}
        onChange={(event)=>this.inputChangedHandlerCliente(event)}
        className="input-global" placeholder="Nombre de Cliente" />
        <br/>
        <button style={{"width":"150px"}} className="button-global"
         onClick={ () => this.getnewClienteFinalizar()}>
          Continuar
        </button>
        <br/>
      </React.Fragment>
    )
  }
  DataEditar =()=>{
    return (
      <React.Fragment>
        <button style={{"width":"150px"}} className="button-global"
         onClick={ () => this.getRegresar()}>
          Regresar
        </button>
        <br/>
        Teléfono:
        <input style={{"width":"100%"}} value={this.state.new_telefono}
        onChange={(event)=>this.inputChangedHandlerTelefono(event)}
        className="input-global" placeholder="Número Telefónico" />
        <br/>
        Cliente:
        <input style={{"width":"100%"}} value={this.state.new_nombre}
        onChange={(event)=>this.inputChangedHandlerCliente(event)}
        className="input-global" placeholder="Nombre de Cliente" />
        <br/>
        <button style={{"width":"150px"}} className="button-global"
         onClick={ () => this.geteditClienteFinalizar()}>
          Continuar
        </button>
        <br/>
      </React.Fragment>
    )
  }
  render (){
    
    const accion = this.state.accion
    let sub_modulo_modal
    if(accion==='busqueda'){
      sub_modulo_modal =<React.Fragment>{this.DataBusqueda()}</React.Fragment>
    }
    if(accion==='nuevo'){
      sub_modulo_modal =<React.Fragment>{this.DataNuevo()}</React.Fragment>
    }
    if(accion==='editar'){
      sub_modulo_modal =<React.Fragment>{this.DataEditar()}</React.Fragment>
    }
    let modal_loading
    const msg_loading = this.state.msg_loading
    if(msg_loading){
      modal_loading = <div id="loader" className="loader loader-default is-active" data-text=""></div>
    }
    return (
      <div style={{"width": "90%","overflowY": "auto","height": "90%","color":"black"}}>
      {sub_modulo_modal}
      <div style={{ whiteSpace: "pre-wrap" }}>
        {this.state.script}
      </div>
      {modal_loading}
      </div>
    )
  }
  componentDidMount (){
    localStorage.setItem("numero_temp","")
    if(this.state.busqueda){
      this.getClientes()
    }
    this.getScript()
  }

  getScript =()=>{
    const url= this.props.dir_url + "webapp/getScript";
    const token =  this.props.token
    var obj = { accion:'datascript', token,tipo:1 };
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      if(data[0].status==="ok"){
        this.setState({
          script :data[0].msg[0].script
        })
      }else{
        this.setState({
          script :""
        })
      }
    })
    .catch(console.log)
  }

}
export default getCCliente;
